import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

import {
  IconButton,
  Snackbar,
  Grid
}  from 'e100-react-components';
import {
  FavouriteStationIcon,
  useIsAddingFavouritStationsDone,
  useStationsOperations
} from 'entities/stations';

import { useBoolState } from 'common/hooks';
import { useStyles } from './styles';
import { useIntl } from 'react-intl';

export const FavouriteStationsAddSnackbar = () => {
  const { formatMessage } = useIntl();
  const [ show,,, onHide, onShow ] = useBoolState(false);
  const classes = useStyles();
  const isAddingFavouritStationsDone = useIsAddingFavouritStationsDone();
  const { updateAddingFavouriteStationsStatus } = useStationsOperations();

  useEffect(() => {
    if (isAddingFavouritStationsDone) {
      onShow();
    }
  }, [
    isAddingFavouritStationsDone,
    onShow
  ]);

  useEffect(() => () => {
    updateAddingFavouriteStationsStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!show) {
    return null;
  }

  return createPortal(
    <Snackbar
      open={show}
      onClose={() => {
        updateAddingFavouriteStationsStatus();
        onHide();
      }}
      message={
        <Grid
          container
          alignItems="center"
          justify="space-between"
          wrap="nowrap"
        >
          <Grid item>
            <FavouriteStationIcon
              color="primary"
            />
          </Grid>
          <Grid item>
            {formatMessage({ id: 'favouriteStations.added.message' })}
          </Grid>
          <Grid item>
            <IconButton
              kind={'close'}
              onClick={onHide}
              color={'inherit'}
            />
          </Grid>
        </Grid>
      }
      classes={{
        root: classes.root
      }}
      autoHideDuration={2000}
    />,
    document.body
  );
};
